/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Item ligero de lista de ofertas [P_E_01] [P_E_02] [P_E_03]
 * @export
 * @interface CompanyOfferItem
 */
export interface CompanyOfferItem {
    /**
     * 
     * @type {number}
     * @memberof CompanyOfferItem
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItem
     */
    title?: string;
    /**
     * normal, fct, dual, external
     * @type {string}
     * @memberof CompanyOfferItem
     */
    modality?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItem
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItem
     */
    expireAt?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOfferItem
     */
    date?: string;
    /**
     * 
     * @type {object}
     * @memberof CompanyOfferItem
     */
    city?: object;
    /**
     * Id Provincia
     * @type {number}
     * @memberof CompanyOfferItem
     */
    state?: number;
    /**
     * Offer status
     * @type {number}
     * @memberof CompanyOfferItem
     */
    status?: number;
    /**
     * on_site, semi, remote
     * @type {string}
     * @memberof CompanyOfferItem
     */
    presence?: string;
    /**
     * Indica si el proceso es remoto
     * @type {boolean}
     * @memberof CompanyOfferItem
     */
    isRemoteProcess?: boolean;
    /**
     * lista de ids
     * @type {Array<number>}
     * @memberof CompanyOfferItem
     */
    academicPrograms?: Array<number>;
    /**
     * count applications group by status
     * @type {Array<object>}
     * @memberof CompanyOfferItem
     */
    counts?: Array<object>;
    /**
     * Indica si la oferta tiene preguntas para incribirse
     * @type {boolean}
     * @memberof CompanyOfferItem
     */
    hasQuestions?: boolean;
}

export function CompanyOfferItemFromJSON(json: any): CompanyOfferItem {
    return CompanyOfferItemFromJSONTyped(json, false);
}

export function CompanyOfferItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOfferItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'modality': !exists(json, 'modality') ? undefined : json['modality'],
        'externalUrl': !exists(json, 'external_url') ? undefined : json['external_url'],
        'expireAt': !exists(json, 'expire_at') ? undefined : json['expire_at'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'presence': !exists(json, 'presence') ? undefined : json['presence'],
        'isRemoteProcess': !exists(json, 'is_remote_process') ? undefined : json['is_remote_process'],
        'academicPrograms': !exists(json, 'academic_programs') ? undefined : json['academic_programs'],
        'counts': !exists(json, 'counts') ? undefined : json['counts'],
        'hasQuestions': !exists(json, 'has_questions') ? undefined : json['has_questions'],
    };
}

export function CompanyOfferItemToJSON(value?: CompanyOfferItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'modality': value.modality,
        'external_url': value.externalUrl,
        'expire_at': value.expireAt,
        'date': value.date,
        'city': value.city,
        'state': value.state,
        'status': value.status,
        'presence': value.presence,
        'is_remote_process': value.isRemoteProcess,
        'academic_programs': value.academicPrograms,
        'counts': value.counts,
        'has_questions': value.hasQuestions,
    };
}


